export const PIT_DEFS = { pitStripe: 'pit-stripe', pitPaypal: 'pit-paypal' }
